<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

interface Props {
  class?: HTMLAttributes["class"]
}

const props = defineProps<Props>()
</script>

<template>
  <div :class="cn('paper-grain motion-safe:animate-paper-breathe rounded-[var(--paper-radius-xs)] bg-popover', props.class)" />
</template>
